import React from 'react';

import styles from './PurchaseBonusSection.module.scss';
import star from '../../assets/images/star.svg';

const PurchaseBonusSection = ({ label, title, items }) => (
    <div className={styles.wrapper}>
        <div className={styles.plate}>
            <div className={styles.plateInner}>
                <img src={star} alt={''} className={styles.star} />
                <div className={styles.plateText}>{label}</div>
                <img src={star} alt={''} className={styles.star} />
            </div>
        </div>
        <div className={styles.bonus}>
            <div className={styles.content}>
                <div className={styles.info}>{title}</div>
                <div className={styles.items}>
                    {items.map((item, index) => (
                        <div key={index} className={`${styles.itemWrapper} ${item.rarity}`}>
                            <img src={item.img} alt={'img'} className={styles.itemImg} />
                            <div className={styles.itemInfo}>
                                <div className={styles.itemLabel}>{item.label}</div>
                                <div className={styles.itemQuantity}>{item.quantity}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </div>
);

export default PurchaseBonusSection;
